var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKazakhstan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.696 258.783H111.304C111.304 278.762 128.705 294.957 148.682 294.957H147.478C147.478 314.936 163.673 331.131 183.652 331.131C183.652 351.11 199.847 367.305 219.826 367.305H292.174C312.153 367.305 328.348 351.11 328.348 331.131C348.327 331.131 364.522 314.936 364.522 294.957H363.318C383.293 294.957 400.696 278.762 400.696 258.783V258.783Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.174 211.478C356.174 266.802 311.324 311.652 256 311.652C200.675 311.652 155.826 266.802 155.826 211.478",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.515 211.478L301.25 226.185L317.899 256.465L283.949 249.97L279.647 284.266L256 259.041L232.352 284.266L228.051 249.97L194.101 256.463L210.749 226.184L179.485 211.478L210.75 196.772L194.101 166.493L228.05 172.987L232.353 138.691L256 163.916L279.648 138.691L283.949 172.987L317.9 166.493L301.251 196.773L332.515 211.478Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKazakhstan);
export default __webpack_public_path__ + "static/media/kazakhstan.7800fccf7ff0f853c4079c26fe17fed7.svg";
export { ForwardRef as ReactComponent };